import { Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'runLoyalPortal';
  isPageLoader: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

    showPageContentLoader(): void {
      this.isPageLoader = true;
      const pageSidebar = this.el.nativeElement.querySelector('#page-sidebar');
      const pageContentLoader = this.el.nativeElement.querySelector('.page-content-loader');
      if (pageSidebar && pageContentLoader) {
        const marginLeft = `${pageSidebar.offsetWidth}px`;
        this.renderer.setStyle(pageContentLoader, 'margin-left', marginLeft);
      }
    }
  
    hidePageContentLoader(): void {
      this.isPageLoader = false;
    }
}
